import React, { ChangeEvent, useId } from 'react';
import clsx from 'clsx';

import { FormItem } from '@/stories/components/Form/FormItem/FormItem';
import { Icon } from '@/stories/atoms/Icon/Icon';
import { FieldProps } from '../Input/Input';
import styles from '@/stories/components/Form/Input/input.module.css';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ObjectOption<T = any> = {
  label?: string,
  value?: T,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any
}

export type InputProps = {
  sizeVariant?: 'small',
  options: ObjectOption[],
} & FieldProps & React.ComponentProps<'select'>

export const Select = ({
  label,
  id,
  value,
  setValue,
  required = false,
  helpText,
  inline,
  hideLabel,
  hideOptionnal,
  icon,
  variant,
  sizeVariant,
  options,
  className,
  ...props
}: InputProps) => {
  const {style, ...inputProps} = props
  const generatedId = useId()

  const handleChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const {value} = e.target
    if (setValue) setValue(value as string)
  }

  return (
    <FormItem
      id={id || generatedId}
      label={label}
      hideLabel={hideLabel}
      inline={inline}
      hideOptionnal={hideOptionnal}
      required={required}
      helpText={helpText}
      style={style}
      className={className}>
      <div className={clsx(styles.wrapper, icon && 'has-icon')}>
        {icon ? <Icon icon={icon} className={styles.icon}/> : null}
        <Icon icon='angle-down' className={styles.carret}/>
        <select
          className={clsx(styles.input, styles.select, variant && styles[variant], sizeVariant && styles[sizeVariant])}
          id={id || generatedId}
          value={value}
          onChange={handleChange}
          required={required} {...inputProps}>
          {options.map(({ value, label }) => <option key={value} value={value}>{label}</option>)}
        </select>
      </div>
    </FormItem>
  )
};
